<template>
  <div
    class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin"
    id="m_login"
  >
    <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
      <div class="m-stack m-stack--hor m-stack--desktop">
        <div class="m-stack__item m-stack__item--fluid">
          <div class="m-login__wrapper">
            <div class="m-login__logo">
              <a href>
                <img src="@/assets/media/img/logo/logo_griffin.svg" />
              </a>
            </div>

            <div class="m-login__signin">
              <div class="m-login__head">
                <h3 class="m-login__title">Fazer login</h3>
              </div>

              <div class="m-login__form m-form">
                <div class="form-group m-form__group">
                  <input
                    data-cy="inputLoginUser"
                    id="email"
                    type="email"
                    class="form-control m-input"
                    name="email"
                    placeholder="Email"
                    v-model="user.email"
                    autocomplete="off"
                  />
                </div>
                <div class="form-group m-form__group">
                  <input
                    data-cy="inputLoginPassword"
                    class="form-control m-input m-login__form-input--last"
                    type="password"
                    placeholder="Senha"
                    v-model="user.password"
                    name="password"
                    @keydown.enter="signin"
                  />
                </div>
                <div class="row m-login__form-sub">
                  <div class="col m--align-left">
                    <label class="m-checkbox m-checkbox--focus">
                      <input type="checkbox" name="remember" /> Lembrar
                      <span></span>
                    </label>
                  </div>
                  <div class="col m--align-right">
                    <a href="javascript:;" id="m_login_forget_password" class="m-link"
                      >Esqueceu a senha?</a
                    >
                  </div>
                </div>
                <div class="m-login__form-action">
                  <button
                    data-cy="btnLogin"
                    id="m_login_signin_submit"
                    class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air"
                    @click="signin"
                  >
                    Entrar
                  </button>
                </div>
              </div>
            </div>

            <div class="m-login__forget-password">
              <div class="m-login__head">
                <h3 class="m-login__title">Esqueceu a senha ?</h3>
                <div class="m-login__desc">Informe seu email para resetar a senha:</div>
              </div>
              <form class="m-login__form m-form" action="">
                <div class="form-group m-form__group">
                  <input
                    class="form-control m-input"
                    type="text"
                    placeholder="Email"
                    name="email"
                    id="m_email"
                    autocomplete="off"
                  />
                </div>
                <div class="m-login__form-action">
                  <button
                    id="m_login_forget_password_submit"
                    class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air mr-4"
                  >
                    Resetar
                  </button>
                  <button
                    id="m_login_forget_password_cancel"
                    class="btn btn-outline-focus m-btn m-btn--pill m-btn--custom"
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content m-grid-item--center"
      :style="`background-position: bottom left; background-attachment: scroll; background-image: url('${require('@/assets/media/img/bg/bg-nw-1.jpg')}');`"
    >
      <div class="m-grid__item">
        <p class="m-login__msg text-center">Sistema de Gestão Financeira</p>
        <h3 class="m-login__welcome"><img src="@/assets/media/img/logo/logo_newway_dark.svg" /></h3>
      </div>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError, localStorageVersion } from '@/global';
import axios from 'axios';

export default {
  name: 'Auth',
  data() {
    return {
      user: {},
    };
  },
  methods: {
    signin() {
      axios
        .post(`${baseApiUrl}/login`, this.user)
        .then((res) => {
          this.$store.commit('setLocalStorageVersion', localStorageVersion);
          this.$store.commit('setUser', res.data);
          this.$store.commit('setToken', res.data.token);
          this.$router.push({ path: '/' });
        })
        .catch(showError);
    },
  },
};
</script>
